/* ICExtract collection page — vanilla, no dependencies.
   Handles: sort auto-submit, mobile filter drawer (focus trap + Escape + scroll lock),
   apply/clear filters (preserving sort), and grid quick-add. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ic-collection]');
  if (!root) return;

  /* ---------- helpers ---------- */
  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'
      ),
      function (el) { return el.offsetParent !== null; }
    );
  }

  /* ---------- sort auto-submit (preserves filters) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-sort]'), function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  /* ---------- sidebar filter form (desktop) ---------- */
  var sidebarForm = document.querySelector('[data-ic-sidebar-form]');
  function submitFilterForm(form) {
    if (!form) return;
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' || el.value == null) return;
      params.append(el.name, el.value);
    });
    var base = window.location.pathname;
    window.location.assign(base + '?' + params.toString());
  }
  if (sidebarForm) {
    sidebarForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFilterForm(sidebarForm);
    });
  }

  /* ---------- mobile filter drawer ---------- */
  var drawer = document.querySelector('[data-ic-filter-drawer]');
  var backdrop = document.querySelector('[data-ic-filter-backdrop]');
  var openBtn = document.querySelector('[data-ic-filter-open]');
  var closeBtn = document.querySelector('[data-ic-filter-close]');
  var applyBtn = document.querySelector('[data-ic-filter-apply]');
  var drawerForm = document.querySelector('[data-ic-filter-form]');
  var lastFocused = null;

  function onKeydown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab' || !drawer) return;
    var els = focusables(drawer);
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    if (backdrop) backdrop.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var els = focusables(drawer);
    if (els.length) els[0].focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    window.setTimeout(function () {
      drawer.hidden = true;
      if (backdrop) backdrop.hidden = true;
    }, 260);
    if (lastFocused) lastFocused.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (applyBtn) applyBtn.addEventListener('click', function () { submitFilterForm(drawerForm); });

  /* ---------- product recommendations (AJAX) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-recommendations]'), function (holder) {
    var url = holder.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('.ic-related__grid');
        if (grid) { holder.innerHTML = grid.outerHTML; }
        else { holder.closest('.ic-related').style.display = 'none'; }
      })
      .catch(function () { var s = holder.closest('.ic-related'); if (s) s.style.display = 'none'; });
  });

  /* ---------- quick add ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-quick-add-btn]'), function (btn) {
    // Shared guard: ic-cart-drawer.js may also bind these buttons. Whichever
    // script runs first claims the button to avoid double add-to-cart.
    if (btn.getAttribute('data-ic-quick-add-bound')) return;
    btn.setAttribute('data-ic-quick-add-bound', '');
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = (window.icStrings && window.icStrings.added) || 'Added';
          document.dispatchEvent(new CustomEvent('ic:cart:added'));
          window.setTimeout(function () { btn.textContent = original; }, 1800);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = original;
        });
    });
  });
})();
